import { createEvent } from 'effector';
import { createGate } from 'effector-react';

export const changeRegionsOkedsModalEv = createEvent();

export const RegionsOkedsGate = createGate();

export const changeRegionModalEv = createEvent();
export const resetRegionModalEv = createEvent();
export const RegionModalGate = createGate();

export const changeDistrictModalEv = createEvent();
export const resetDistrictModalEv = createEvent();
export const DistrictModalGate = createGate();

export const changeOkedsModalEv = createEvent();
export const resetOkedsModalEv = createEvent();
export const OkedsModalGate = createGate();

export const changeSubOkedsModalEv = createEvent();
export const resetSubOkedsModalEv = createEvent();
export const SubOkedsModalGate = createGate();

export const changeOkedsModalsFiltersEv = createEvent();
